export const SET_PAGINATION = 'SET_PAGINATION';
export const REMOVE_PAGINATION = 'REMOVE_PAGINATION';
export const GO_TO_PAGE = 'GO_TO_PAGE';
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE';
export const SET_SORT_BY = 'SET_SORT_BY';
export const REMOVE_SORTING = 'REMOVE_SORTING';
export const SET_SEARCH = 'SET_SEARCH';
export const REMOVE_SEARCH = 'REMOVE_SEARCH';
export const SET_FILTER = 'SET_FILTER';
export const REMOVE_FILTER = 'REMOVE_FILTER';
export const REMOVE_PAGES = 'REMOVE_PAGES';
export const SET_SCHEDULE_FILTER = 'SET_SCHEDULE_FILTER';
export const SET_ROSTER_FILTER = 'SET_ROSTER_FILTER';
export const SET_WAITLIST_FILTER = 'SET_WAITLIST_FILTER';
export const SET_ATTENDANCE_FILTER = 'SET_ATTENDANCE_FILTER';
export const SET_DROPIN_FILTER = 'SET_DROPIN_FILTER';
export const REMOVE_ALL_FILTERS = 'REMOVE_ALL_FILTERS';


// WEBPACK FOOTER //
// ./src/store/modules/page/mutations.js